<div class="lm-flex-row-responsive-container">
  <ng-container [ngTemplateOutlet]="PDF"></ng-container>
  <ng-container [ngTemplateOutlet]="DISPLAY_SEARCH"></ng-container>
  @if (model.charts) {
    <ng-container [ngTemplateOutlet]="INITIAL_VIEW"></ng-container>
  }
  @if (reportCatalogEnabled && model.isReport) {
    <ng-container [ngTemplateOutlet]="REPORT"></ng-container>
  }

</div>
<ng-template #PDF>
  <div class="lm-report-widget">
    <h2 class="fieldset-title">{{ 'PrintToFile' | translate }}</h2>
    <div class="field field-radio lm-padding-top">
      <input
        data-automation-id="lm-personalization-pdf-landscape-orientation"
        type="radio" class="radio" id="landscape" value="landscape" [(ngModel)]="model.orientation" soho-trackdirty />
        <label for="landscape" class="radio-label">{{'PDFOrientationLandscape' | translate}}</label>
        <input
          data-automation-id="lm-personalization-pdf-portrait-orientation"
          type="radio" class="radio" id="portrait" value="portrait" [(ngModel)]="model.orientation" soho-trackdirty />
          <label for="portrait" class="radio-label">{{'PDFOrientationPortrait' | translate}}</label>
        </div>
        <div class="field">
          <label soho-label for="pageSize">{{'PDFPageSize' | translate}}</label>
          <select soho-dropdown
            id="pageSize"
            data-automation-id="lm-personalization-pdf-paper-size"
            [(ngModel)]="model.paperSize"
            [attributes]="pdfPaperSizeDropdownAttributes"
            noSearch
            soho-trackdirty
            class="dropdown-md">
            @for (option of paperSizeList | async; track option) {
              <option [value]="option.value">{{option.description}}</option>
            }
          </select>
          @if (model.paperSize === 'Custom') {
            <div id="info-custom" class="info-message" data-automation-id="lm-personalization-pdf-custom-info">
              <svg class="icon-info icon" focusable="false" aria-hidden="true" role="presentation">
                <use href="#icon-info"></use>
              </svg>
              <pre class="audible">Info</pre>
              <p class="message-text">{{'PageSizeMaximumDigits' | translate}}</p>
            </div>
          }
        </div>
        @if (model.paperSize === 'Custom') {
          <div class="field">
            <label soho-label for="customWidth">{{'PageWidth' | translate}}</label>
            <input id="customWidth" [(ngModel)]="model.customPageWidth" data-automation-id="lm-personalization-pdf-custom-width"
              data-validate="required invalidPageSize" soho-trackdirty class="input-md"/>
            </div>
          }
          @if (model.paperSize === 'Custom') {
            <div class="field">
              <label soho-label for="customWidth">{{'PageHeight' | translate}}</label>
              <input id="customHeight" [(ngModel)]="model.customPageHeight" data-automation-id="lm-personalization-pdf-custom-width"
                data-validate="required invalidPageSize" soho-trackdirty class="input-md"/>
              </div>
            }
            @if (model.paperSize === 'Custom') {
              <div class="field">
                <label soho-label for="unitOfMeasure">{{'UnitOfMeasure' | translate}}</label>
                <select soho-dropdown id="unitOfMeasure" [(ngModel)]="model.customPageSizeUnit" data-automation-id="lm-personalization-pdf-unit-of-measure" noSearch soho-trackdirty class="dropdown-sm">
                  <option [value]="'Inch'">{{'PDFPageSizeInches' | translate}}</option>
                  <option [value]="'Centimter'">{{'PDFPageSizeCentimeters' | translate}}</option>
                  <option [value]="'Points'">{{'PDFPageSizePoints' | translate}}</option>
                </select>
              </div>
            }
            <div class="lm-flex-row-responsive-container">
              <div class="field lm-padding-right">
                <label soho-label for="lm-personalization-pdf-font-offset-option">{{'PDFFontSizeOffset' | translate}}</label>
                <select data-automation-id="lm-personalization-pdf-font-offset-option" class="dropdown-md"
                  soho-dropdown
                  id="lm-personalization-pdf-font-offset-option"
                  [attributes]="pdfFontOffsetOptionDropdownAttributes"
                  noSearch soho-trackdirty
                  (change)="onFontOffsetOptionChange($event)"
                  [(ngModel)]="model.fontOffsetOption"
                  >
                  <option [value]="'default'">{{'PDFFontSizeOffsetDefault' | translate}}</option>
                  <option [value]="'small'">{{'PDFFontSizeOffsetSmall' | translate}}</option>
                  <option [value]="'smaller'">{{'PDFFontSizeOffsetSmaller' | translate}}</option>
                  <option [value]="'smallest'">{{'PDFFontSizeOffsetSmallest' | translate}}</option>
                  <option [value]="'custom'">{{'PDFFontSizeOffsetCustom' | translate}}</option>
                </select>
              </div>
              @if (model.fontOffsetOption === 'custom') {
                <div class="field lm-no-label two columns" >
                  <label soho-label for="lm-personalization-pdf-font-offset"></label>
                  <!-- soho-spin box doesn't have an attributes input. So instead attributes is
                  being placed on the data-options attribute. That will then get picked up by
                  spinbox.js in ids-enterprise.
                  -->
                  <input data-automation-id="lm-personalization-pdf-font-offset"
                    class="input-xs"
                    soho-spinbox
                    id="lm-personalization-pdf-font-offset"
                    attr.data-options="{{customFontOffsetSpinBoxDataOptions}}"
                    [(ngModel)]="model.fontOffset"/>
                  </div>
                }
              </div>
              @if (!(model.listType === 'tree' || model.listType === 'cube')) {
                <div class="field lm-padding-right">
                  <label soho-label for="lm-personalization-page-size-option">{{ 'PageSize' | translate }}</label>
                  <select data-automation-id="lm-personalization-page-size-option" class="dropdown-md"
                    soho-dropdown
                    id="lm-personalization-page-size-option"
                    [attributes]="pageSizeOptionDropdownAttributes"
                    noSearch soho-trackdirty
                    [(ngModel)]="model.showLines"
                    >
                    @for (pageSize of pageSizes; track pageSize) {
                      <option [value]="pageSize">{{ pageSize }}</option>
                    }
                  </select>
                </div>
              }
              <div class="field">
                <input
                  soho-checkbox
                  type="checkbox"
                  soho-trackdirty
                  id="lm-personalization-show-grd-lines-checkbox"
                  name="lm-personalization-show-grd-lines-checkbox"
                  data-automation-id="lm-personalization-show-grd-lines-checkbox"
                  [(ngModel)]="model.showGridLines"
                  >
                  <label
                    soho-label
                    for="lm-personalization-show-grd-lines-checkbox"
                  [forCheckBox]="true">{{'Show_Grid_Lines' | translate}}</label>
                </div>
                <div class="field">
                  <input
                    soho-checkbox
                    type="checkbox"
                    soho-trackdirty
                    id="lm-personalization-show-header-checkbox"
                    name="lm-personalization-show-header-checkbox"
                    data-automation-id="lm-personalization-suppress-header-checkbox"
                    [(ngModel)]="model.suppressHeader"
                    >
                    <label
                      soho-label
                      for="lm-personalization-show-header-checkbox"
                    [forCheckBox]="true">{{'Suppress_Headers' | translate}}</label>
                  </div>
                  <div class="field">
                    <input
                      soho-checkbox
                      type="checkbox"
                      soho-trackdirty
                      id="lm-personalization-show-footer-checkbox"
                      name="lm-personalization-show-footer-checkbox"
                      data-automation-id="lm-personalization-suppress-footer-checkbox"
                      [(ngModel)]="model.suppressFooter"
                      >
                      <label
                        soho-label
                        for="lm-personalization-show-footer-checkbox"
                      [forCheckBox]="true">{{'Suppress_Footer' | translate}}</label>
                    </div>
                      <div class="field">
                          <input
                                  soho-checkbox
                                  type="checkbox"
                                  soho-trackdirty
                                  id="lm-personalization-display-negative-parentheses-checkbox"
                                  name="lm-personalization-display-negative-parentheses-checkbox"
                                  data-automation-id="lm-personalization-display-negative-parentheses-checkbox"
                                  [(ngModel)]="model.displayNegInParens"
                          >
                          <label
                                  soho-label
                                  for="lm-personalization-display-negative-parentheses-checkbox"
                                  [forCheckBox]="true">{{'ListPersonalizationDisplayNegativeInParens' | translate}}</label>
                      </div>
                    <div class="field">
                      <input
                        soho-checkbox
                        type="checkbox"
                        soho-trackdirty
                        id="lm-personalization-enable-horizontal-scrolling-checkbox"
                        name="lm-personalization-enable-horizontal-scrolling-checkbox"
                        data-automation-id="lm-personalization-enable-horizontal-scrolling-checkbox"
                        [(ngModel)]="model.horizontalScrolling"
                        >
                        <label
                          soho-label
                          for="lm-personalization-enable-horizontal-scrolling-checkbox"
                        [forCheckBox]="true">{{'EnableHorizontalScrolling' | translate}}</label>
                      </div>
                      @if (model.horizontalScrolling && numberOfColumns$ | async; as numberOfCol) {
                        <div class="field">
                          <label soho-label for="lm-personalization-columns-to-freeze">{{'ColumnsToFreeze' | translate}}</label>
                          <input data-automation-id="lm-personalization-columns-to-freeze"
                            class="input-xs"
                            soho-spinbox
                            soho-trackdirty
                            id="lm-personalization-columns-to-freeze"
                            [attr.data-options]="columnsToFreezeSpinBoxDataOptions"
                            [max]="numberOfCol"
                            [(ngModel)]="model.columnsToFreeze"
                            />
                            <div class="info-message" data-automation-id="lm-personalization-columns-to-freeze-warning">
                              <svg class="icon-info icon" focusable="false" aria-hidden="true" role="presentation">
                                <use href="#icon-info"></use>
                              </svg>
                              <pre class="audible">Info</pre>
                              <p class="message-text">{{'ColumnsToFreezeWarning' | translate}}</p>
                            </div>
                          </div>
                        }
                      </div>
                    </ng-template>

                    <ng-template #DISPLAY_SEARCH>
                      <div class="lm-report-widget">
                        <h2 class="fieldset-title">{{'DisplaySearch' | translate}}</h2>
                        <div class="field">
                          <select soho-dropdown id="displaySearch" [(ngModel)]="model.displaySearch"
                            data-automation-id="lm-personalization-display-search"
                            [attributes]="displaySearchDropdownAttributes"
                            noSearch soho-trackdirty class="dropdown-md">
                            <option [value]="'default'">{{'DisplaySearchDefaultLabel' | translate}}</option>
                            <option [value]="'initially'">{{'InitiallyDisplaySearchLabel' | translate}}</option>
                            <option [value]="'always'">{{'AlwaysDisplaySearchLabel' | translate}}</option>
                          </select>
                        </div>
                      </div>
                    </ng-template>

                    <ng-template #INITIAL_VIEW>
                      <div class="lm-report-widget">
                        <h2 class="fieldset-title">{{'CreateReportDefViewLabel' | translate}}</h2>
                        <div class="field">
                          <select soho-dropdown
                            id="viewName"
                            name="viewName"
                            data-automation-id="lm-personalization-view-name"
                            [attributes]="viewNameDropdownAttributes"
                            [source]="viewNameSource"
                            [(ngModel)]="model.viewName"
                            soho-trackdirty
                            >
                            <option [value]="'list'">{{ 'list' | translate }}</option>
                            @for (viewName of model.charts; track viewName) {
                              <option [value]="viewName">{{viewName}}</option>
                            }
                          </select>
                        </div>
                      </div>
                    </ng-template>

                    <ng-template #REPORT>
                      <div class="lm-report-widget">
                        <h2 class="fieldset-title">{{ 'ListPersonalizationApplicationReportAndCategory' | translate }}</h2>
                        <div class="field">
                          <label
                            soho-label
                            for="lm-personalization-app-report-module"
                            >
                            {{ 'ListPersonalizationModule' | translate }}
                          </label>
                          <select
                            data-automation-id="lm-personalization-app-report-module"
                            id="lm-personalization-app-report-module"
                            name="lm-personalization-app-report-module"
                            attr.placeholder="Available Category"
                            soho-dropdown
                            soho-trackdirty
                            soho-alert
                            [id]="'lm-personalization-app-report-module'"
                            [attributes]="categoryDropdownAttributes"
                            [moveSelected]="true"
                            [(ngModel)]="model.module"
                            (ngModelChange)="onModuleChanged()"
                            soho-busyindicator
                            blockUI="true"
                            displayDelay="0"
                            [source]="onModuleSelect"
                            >
                            @for (item of appReport.modules; track item) {
                              <option
                                selected="{{item?.selected}}"
                                [value]="item?.value">{{item?.label}}
                              </option>
                            }
                          </select>
                        </div>
                        <div class="field">
                          <label
                            soho-label
                            for="lm-personalization-app-report-category"
                            >
                            {{ 'ListPersonalizationCategory' | translate }}
                          </label>
                          <select
                            data-automation-id="lm-personalization-app-report-category"
                            id="lm-personalization-app-report-category"
                            name="lm-personalization-app-report-category"
                            attr.placeholder="Available Subcategory"
                            soho-dropdown
                            soho-trackdirty
                            soho-alert
                            [id]="'lm-personalization-app-report-category'"
                            [attributes]="subCategoryDropdownAttributes"
                            [moveSelected]="true"
                            [(ngModel)]="model.category"
                            soho-busyindicator
                            blockUI="true"
                            displayDelay="0"
                            [source]="onCategorySelect"
                            >
                            @for (item of appReport.categories; track item) {
                              <option
                                selected="{{item?.selected}}"
                                [value]="item?.value">{{item?.label}}
                              </option>
                            }
                          </select>
                        </div>
                        <div class="field">
                          <label
                            soho-label
                            for="lm-personalization-app-report-description"
                            >{{ 'Description' | translate }}
                          </label>
                          <textarea
                            [attr.id]="'reportDescription'"
                            data-automation-id="lm-personalization-app-report-description"
                            name="reportDescription"
                            spellcheck="true"
                            soho-textarea
                            soho-alert
                            [id]="'lm-personalization-app-report-description'"
                            soho-trackdirty
                            [(ngModel)]="model.description">
                          </textarea>
                        </div>
                        <h2 class="fieldset-title">{{ 'RetentionDurationOption' | translate }}</h2>
                        <div class="lm-flex-row-responsive-container">
                          <div class="field lm-padding-right">
                          <!--label soho-label for="lm-personalization-retention-duration-option">{{'RetentionDurationOption' | translate}}</label-->
                          <select data-automation-id="lm-personalization-retention-duration-option" class="dropdown-md"
                            soho-dropdown
                            id="lm-personalization-retention-duration-option"
                            [attributes]="retentionDurationOptionDropdownAttributes"
                            noSearch soho-trackdirty
                            (change)="onRetentionDurationOptionChange($event)"
                            [(ngModel)]="model.retentionDurationOption"
                            >
                            <option [value]="'default'">{{'RetentionDurationOptionDefault' | translate}}</option>
                            <option [value]="'one-week'">{{'RetentionDurationOptionWeek' | translate}}</option>
                            <option [value]="'one-month'">{{'RetentionDurationOptionMonth' | translate}}</option>
                            <option [value]="'one-year'">{{'RetentionDurationOptionYear' | translate}}</option>
                            <option [value]="'five-years'">{{'RetentionDurationOptionFiveYear' | translate}}</option>
                            <option [value]="'custom'">{{'RetentionDurationOptionCustom' | translate}}</option>
                          </select>
                        </div>
                        @if (model.retentionDurationOption === 'custom') {
                          <div class="field lm-no-label two columns" >
                          <!--label soho-label for="lm-personalization-retention-duration"></label-->
                          <!-- soho-spin box doesn't have an attributes input. So instead attributes is
                          being placed on the data-options attribute. That will then get picked up by
                          spinbox.js in ids-enterprise.
                          -->
                          <input data-automation-id="lm-personalization-retention-duration"
                            class="input-sm"
                            soho-spinbox
                            id="lm-personalization-retention-duration"
                            attr.data-options="{{retentionDurationSpinBoxDataOptions}}"
                            [(ngModel)]="model.retentionDuration"/>
                          </div>
                        }
                      </div>
                    </div>
                  </ng-template>

